import { genId } from "../../../utils";

export const topBlockSchema = {
  _id: genId(),
  name: 'topBlockSchema',
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: {as: 'div', className: "schema constant-block"},
      children: [
        {
          name: 'header',
          type: 'Container',
          displaySettings: { as: 'Container', className: "block-header block-header-top" },
          children: [

            {
              name: 'headerInputs',
              type: 'Container',
              displaySettings: { as: 'div', className: "header-inputs" },
              children: [
                {
                  name: 'repTypeRow',
                  type: 'Container',
                  displaySettings: { as: 'div'},
                  children: [{
                    name: 'reportType',
                    type: 'text',
                    displaySettings: { size: 'lg', className: 'report-type-input'   },
                    placeholder: 'Report Type',

                  }]
                },
                {
                  name: 'repNameRow',
                  type: 'Container',
                  displaySettings: {as: 'div', className: 'flex-grow-1'},
                  children: [
                    {
                      name: 'name',
                      type: 'text',
                      displaySettings: {  visualVariant: 'plain', className: 'report-name-input'  },
                      placeholder: 'Report Title',

                    },
                  ]
                }
                ]
            },
            {
          name: 'utilsContainer',
          type: 'Container',
          displaySettings: { as: 'div' },
          children: [
            {
              name:'utilsRow',
              type: 'Container',
              displaySettings:{as:'div'},
              children:[
                {name:'reportBlockUtilities', type: 'reportBlockUtilities'}
              ]
            },
          ]
        } 
      ]
      },
        {
          name: 'titleContainer',
          type: 'Container',
          displaySettings: { as: 'Container', className:'block-body' },
          children: [
            {
              name:'propAddressRow',
              type:'Container',
              displaySettings: {as: 'Row', },
              children:[
                {
                  name: 'propertyAddress',
                  type: 'text',
                  displaySettings:{  },
                  placeholder: 'Property Address',
                  label: 'Property Address'
                },
    
              ]
            },
            {
              name:'coverRow',
              type:'Container',
              displaySettings: {as: 'Row', className:'report-cover-photo-row'},
              children:[
                {
                  name: 'coverPhoto',
                  type: 'image',
                  displaySettings:{ className: 'report-cover-photo' },
                  placeholder: 'Cover Photo',
                  options: {thumbnailSize:'lg'},
                  label: 'Cover Photo'
                },
              ]
            },
            {
              name:'preparedRow',
              type:'Container',
              displaySettings:{as: 'Row', className:'report-prepared-row'},
              children: [
                {
                  name:'dateCol',
                  type:'Container',
                  displaySettings:{as: 'Col', sm: 4, className:'report-prepared-date-col'},
                  children: [
                    {
                      name: 'date',
                      type: 'text',
                      placeholder: 'Date',
                      label: 'Date:'
                    }
                  ]
                },
                {
                  name:'preparedForCol',
                  type:'Container',
                  displaySettings:{as: 'Col', sm:4, className:'report-prepared-for-col'},
                  children: [
                    {
                      name:'preparedForPhotoContainer',
                      type:'Container',
                      displaySettings:{as:'Container', className:'report-prepared-image-container'},
                      children:[
                        {
                          name: 'preparedForPhoto',
                          type: 'image',
                          displaySettings:{ className: 'report-prepared-image'},
                          label: 'Prepared For:',
                        },
                      ]
                    },
                    {
                      name: 'preparedFor',
                      type: 'text',
                      placeholder: 'Prepared For (Client)',
                      label: 'Prepared For (Client)'
                    },
                    {
                      name: 'preparedForAddress',
                      type: 'text',
                      displaySettings:{as:'textarea'},
                      placeholder: 'Prepared For Address',
                      label: 'Prepared For Address'
                    },
                  ]
                },
                {
                  name:'preparedByCol',
                  type:'Container',
                  displaySettings:{as: 'Col', sm:4, className:'report-prepared-by-col'},
                  children: [
                    {
                      name:'preparedByPhotoContainer',
                      type:'Container',
                      displaySettings:{as:'Container', className:'report-prepared-image-container'},
                      children:[
                        {
                          name: 'preparedByPhoto',
                          type: 'image',
                          displaySettings:{ className: 'report-prepared-image report-prepared-by-image'},
                          label: 'Prepared By:'
                        },
                      ]
                    },
                    {
                      name: 'preparedBy',
                      type: 'text',
                      placeholder: 'Prepared By',
                      label: 'Prepared By'
                    },
                    {
                      name: 'preparedByAddress',
                      type: 'text',
                      displaySettings:{as:'textarea'},
                      placeholder: 'Prepared By Address',
                      label: 'Prepared By Address'
                    },
                  ]
                }
              ]
            }
          ]
        },
        {
          name: 'projectSummaryContainer',
          type:'Container',
          displaySettings: { as: 'Container', className:'block-body report-project-summary-container'},
          children:[
            {
              name: 'projectManagerStatement',
              type: 'markdown',
              label: 'Project Manager\'s Statement',
              displaySettings: {labelProps: { className: 'report-summary-label'}/*, enableChat: true*/}
            },
            {
              name:'preparedRow',
              type:'Container',
              displaySettings:{as: 'Row'},
              children: [
                {
                  name:'dateCol',
                  type:'Container',
                  displaySettings:{as: 'Col', sm: 6, className:'block-body'},
                  children: [
                    {
                      name: 'signatorsName',
                      type: 'text',
                      placeholder: 'Signator\'s Name',
                      label: 'Signator\'s Name'
                    },
                    {
                      name: 'signatorsTitle',
                      type: 'text',
                      placeholder: 'Signator\'s Title',
                      label: 'Signator\'s Title',
                    },
                    { 
                      name: 'preparedByAddress',
                      type: 'text',
                      placeholder:'preparedByAddress',
                      label:'Prepared By Address'
                    }
                  ]
                },
                {
                  name:'dateCol',
                  type:'Container',
                  displaySettings:{as: 'Col', sm: 6},
                  children: [
                    {
                      name: 'signature',
                      type: 'image',
                      placeholder: 'Signature',
                      displaySettings: {className: 'report-signature-image'},
                      label: 'Signature'
                    }
                  ]
                }
              ]
            },
           
            
          ]
        },
        {
          name:'executiveSummaryContainer',
          type: 'Container',
          displaySettings: { as: 'Container', className: 'block-body' },
          children:[
            {
              name: 'executiveSummary',
              type: 'markdown',
              displaySettings: {labelProps: { className: 'report-summary-label'}/*, enableChat: true*/},
              label: 'Executive Summary'
            }
          ]
        },
      ]
    }
  ]
}